import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, DollarSignIcon, UsersIcon, PercentIcon, BarChart2Icon } from 'lucide-react';
const MetricsOverview = () => {
  const metrics = [{
    title: 'Monthly Recurring Revenue',
    value: '$24,531',
    change: '+12.5%',
    isPositive: true,
    icon: <DollarSignIcon size={24} className="text-blue-600" />,
    description: 'vs. previous month'
  }, {
    title: 'Annual Recurring Revenue',
    value: '$294,372',
    change: '+8.2%',
    isPositive: true,
    icon: <BarChart2Icon size={24} className="text-indigo-600" />,
    description: 'vs. previous year'
  }, {
    title: 'Active Customers',
    value: '1,284',
    change: '+24',
    isPositive: true,
    icon: <UsersIcon size={24} className="text-green-600" />,
    description: 'new this month'
  }, {
    title: 'Churn Rate',
    value: '3.2%',
    change: '-0.5%',
    isPositive: true,
    icon: <PercentIcon size={24} className="text-red-600" />,
    description: 'vs. previous month'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div className="h-12 w-12 rounded-lg bg-gray-50 flex items-center justify-center">
              {metric.icon}
            </div>
            {metric.isPositive ? <span className="flex items-center text-sm text-green-600 font-medium">
                <TrendingUpIcon size={16} className="mr-1" />
                {metric.change}
              </span> : <span className="flex items-center text-sm text-red-600 font-medium">
                <TrendingDownIcon size={16} className="mr-1" />
                {metric.change}
              </span>}
          </div>
          <div className="mt-4">
            <h3 className="text-sm font-medium text-gray-500">
              {metric.title}
            </h3>
            <p className="mt-2 text-3xl font-bold text-gray-900">
              {metric.value}
            </p>
            <p className="mt-1 text-xs text-gray-500">{metric.description}</p>
          </div>
        </div>)}
    </div>;
};
export default MetricsOverview;